import gql from "graphql-tag";

export const ROOM_TYPES = gql`
  query roomTypes {
    roomTypes
  }
`;